"use client";

import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ALL_CHAINS } from "../../../../anyspend/index.js";
import { cn } from "../../../../shared/utils/cn.js";
import { ShinyButton } from "../../../../global-account/react/index.js";
import { Home } from "lucide-react";
import { useAnySpendCustomization } from "../context/AnySpendCustomizationContext.js";
import { AnimatedCheckmark } from "../icons/AnimatedCheckmark.js";
import { ChainTokenIcon } from "./ChainTokenIcon.js";
/**
 * A component for displaying the result of a pure transfer (same chain, same token).
 * Shows the transferred amount with success styling.
 */
export function TransferResultScreen(t0) {
  const $ = _c(15);
  const {
    mode: t1,
    transferResult,
    token,
    chainId,
    recipientAddress,
    onBack,
    onClose
  } = t0;
  const mode = t1 === undefined ? "modal" : t1;
  const chain = ALL_CHAINS[chainId];
  const {
    content
  } = useAnySpendCustomization();
  let t2;
  if ($[0] !== onBack || $[1] !== onClose) {
    t2 = () => {
      if (onClose) {
        onClose();
      } else {
        if (onBack) {
          onBack();
        }
      }
    };
    $[0] = onBack;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClose = t2;
  const t3 = mode === "page" && "border-as-border-secondary overflow-hidden rounded-2xl border shadow-xl";
  let t4;
  if ($[3] !== chain?.logoUrl || $[4] !== chain?.name || $[5] !== content.successDescription || $[6] !== content.successTitle || $[7] !== handleClose || $[8] !== mode || $[9] !== recipientAddress || $[10] !== t3 || $[11] !== token.metadata?.logoURI || $[12] !== token.symbol || $[13] !== transferResult.formattedAmount) {
    t4 = _jsx("div", {
      className: cn("anyspend-container anyspend-transfer-result font-inter bg-as-surface-primary mx-auto w-full max-w-[460px] p-6", t3),
      children: _jsxs("div", {
        className: "anyspend-transfer-result-content flex flex-col items-center gap-6",
        children: [_jsx("div", {
          className: "anyspend-transfer-success-icon",
          children: _jsx(AnimatedCheckmark, {
            className: "h-16 w-16"
          })
        }), _jsxs("div", {
          className: "anyspend-transfer-success-message flex flex-col items-center gap-2",
          children: [_jsx("h2", {
            className: "text-as-primary text-xl font-semibold",
            children: content.successTitle || "Transfer Received!"
          }), _jsx("p", {
            className: "text-as-secondary text-center text-sm",
            children: content.successDescription || "Your transfer has been successfully received."
          })]
        }), _jsx("div", {
          className: "anyspend-transfer-amount border-as-border-secondary bg-as-surface-secondary flex w-full flex-col items-center gap-3 rounded-xl border p-4",
          children: _jsxs("div", {
            className: "flex items-center gap-3",
            children: [_jsx(ChainTokenIcon, {
              chainUrl: chain?.logoUrl,
              tokenUrl: token.metadata?.logoURI,
              className: "h-10 min-h-10 w-10 min-w-10"
            }), _jsxs("div", {
              className: "flex flex-col",
              children: [_jsxs("span", {
                className: "text-as-primary text-2xl font-bold",
                children: [transferResult.formattedAmount, " ", token.symbol]
              }), _jsxs("span", {
                className: "text-as-secondary text-sm",
                children: ["on ", chain?.name ?? "Unknown Chain"]
              })]
            })]
          })
        }), _jsxs("div", {
          className: "anyspend-transfer-recipient flex w-full flex-col gap-1",
          children: [_jsx("span", {
            className: "text-as-secondary text-xs",
            children: "Received at"
          }), _jsx("span", {
            className: "text-as-primary break-all font-mono text-sm",
            children: recipientAddress
          })]
        }), _jsx(ShinyButton, {
          accentColor: "hsl(var(--as-brand))",
          onClick: handleClose,
          className: "anyspend-transfer-close-button w-full",
          textClassName: "text-white",
          children: mode === "page" ? _jsxs("span", {
            className: "flex items-center justify-center gap-2",
            children: ["Return to Home ", _jsx(Home, {
              className: "ml-2 h-4 w-4"
            })]
          }) : "Close"
        })]
      })
    });
    $[3] = chain?.logoUrl;
    $[4] = chain?.name;
    $[5] = content.successDescription;
    $[6] = content.successTitle;
    $[7] = handleClose;
    $[8] = mode;
    $[9] = recipientAddress;
    $[10] = t3;
    $[11] = token.metadata?.logoURI;
    $[12] = token.symbol;
    $[13] = transferResult.formattedAmount;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}